import { safeLocalStorageSetJson } from "../lib/storageQuotaRecovery";
export function persistSessionAndFarm(nextSession, setSession, activeFarm = null, setActiveFarm = null) {
  try {
    if (typeof setSession === "function") setSession(nextSession);
    try { safeLocalStorageSetJson("fz:session", nextSession); } catch (_) {}
    if (nextSession?.role !== "colaborador" && activeFarm && typeof setActiveFarm === "function") {
      setActiveFarm(activeFarm);
      try { safeLocalStorageSetJson("fz:activeFarm", activeFarm); } catch (_) {}
    }
  } catch (e) {}
}

export function shouldShowBlockingBoot({ session, blockingVersionCheck = false, blockingPreSync = false }) {
  return !session && (blockingVersionCheck || blockingPreSync);
}

export function shouldShowLogin({ session }) {
  return !session;
}

export function shouldShowAdmin({ session }) {
  return session?.role === "admin";
}

export function shouldShowGestor({ session }) {
  return session?.role === "gestor";
}
